var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-alert',{attrs:{"value":true,"type":"error"}},[_vm._v("Oops! There was an error loading this page. See console for details")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }